import {
  Button,
  Divider,
  Group,
  Stack,
  useWindowProperties,
} from '@qred/components-library';
import React from 'react';
import ProgressStepperDots from '~/components/shared/ProgressStepperDots/ProgressStepperDots';
import useTranslate from '~/hooks/useTranslate';
import { StepConfigItem } from '~/Interfaces';
import { navbarDividerThickness, navbarHeight } from '~/styles/index.css';

interface NavbarProps {
  showBackButton?: boolean;
  onBackClick?: () => void;
  progressStepperDots?: {
    steps: Pick<StepConfigItem, 'name' | 'hideInProgressStepper'>[];
    currentStep: number;
  };
}

const Navbar = ({
  showBackButton,
  onBackClick,
  progressStepperDots,
}: NavbarProps) => {
  const { isMobile } = useWindowProperties();
  const t = useTranslate();

  return (
    <Stack
      spacing={0}
      w="100%"
      maw={'800px'}
      h={navbarHeight}
      justify="center"
      bg={isMobile ? 'textLight.1' : 'transparent'}
    >
      {isMobile && (
        <Divider
          w={'100%'}
          thickness={navbarDividerThickness}
          color="Border/Minimal"
        />
      )}
      <Group
        pos="relative"
        align="center"
        justify="center"
        style={{
          flexGrow: 1,
        }}
      >
        <Group pos="absolute" left="8px">
          {showBackButton && onBackClick && (
            <Button
              leftIcon="arrow_back_ios"
              data-cy="navbar_back_button"
              data-testid="navbar_back_button"
              onClick={onBackClick}
              variant="tertiary"
            >
              {!isMobile && t('Back')}
            </Button>
          )}
        </Group>
        {progressStepperDots && (
          <ProgressStepperDots
            steps={progressStepperDots.steps}
            currentStep={progressStepperDots.currentStep}
          />
        )}
      </Group>
    </Stack>
  );
};

export default Navbar;
